import React, { useState, useEffect } from "react";
import { Auth } from "aws-amplify";
import Swal from "sweetalert2";
import "antd/dist/antd.css";
import "./index.css";
import { SwitcherFilled, FileTextFilled } from "@ant-design/icons";
import { Breadcrumb, Layout, Menu, Card, Popover } from "antd";
import Approver4 from "../Approver/approver4";
import Approver5 from "../Approver/approver5";
import LocationalClearance from "../PermitOfficer/locationalClearance";
import LocationalReports from "../../pages/Locational Report/LocationalReport";
import CheckPaidOp from "../../pages/Check Paid/CheckPaidOp";
import Admin from "../../pages/Admin/admin";
import COE from "../../pages/COE Form/COEForm";

const { Header, Content, Footer, Sider } = Layout;

const user = JSON.parse(localStorage.getItem("profile"));

const Home = (props) => {
  const [collapsed, setCollapsed] = useState(true);
  const [division, setDivision] = useState("");
  const [content, setContent] = useState("");
  const [role, setRole] = useState("");
  const [status, setStatus] = useState("");
  const [userId, setUserId] = useState();
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  // Helper function to retrieve stored values from localStorage
  const getStoredValue = (key) => {
    if (key === "role") {
      const value = localStorage.getItem(key);
      return value ? value : null;
    } else if (key === "profile") {
      const value = localStorage.getItem(key);
      return value ? JSON.parse(value) : null;
    }
  };

  // Function to check login status and retrieve user information
  const checkLoginStatus = async () => {
    try {
      if (!localStorage.getItem("isLogin")) {
        window.location.pathname = "/login";
        setIsLoggedIn(false);
      } else {
        const storedProfile = getStoredValue("profile");
        if (storedProfile && storedProfile.status === "Pending") {
          window.location.pathname = "/home";
        } else {
          setIsLoggedIn(true);
          setRole(getStoredValue("role"));
          setStatus(storedProfile?.status);
          setUserId(storedProfile?.id);
          setDivision(storedProfile?.division);
        }
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    const role = getStoredValue("role");

    if (role === "permitofficer") {
      setContent("managelocationalclearance");
    } else if (role === "admin") {
      setContent("managelocationalPermitAdmin");
    }

    checkLoginStatus();
  }, []);


  const contents = (
    <div className="profileContent">
      <div style={{ color: "red" }} onClick={() => props.logout()}>
        Logout
      </div>
    </div>
  );

  return (
    <>
      {isLoggedIn ? (
        <Layout
          style={{
            minHeight: "100vh",
            overflow: "auto !important",
          }}
        >
          <Sider
            collapsible
            collapsed={true}
            onCollapse={(value) => setCollapsed(value)}
          >
            <div className="logo">
              {/* <img
                src="https://quezoncity.gov.ph/wp-content/themes/qcproject/images/qclogo_main.png"
                alt="QCLogo"
                width="60"
                height="50"
                style={{ marginTop: -10 }}
              /> */}
            </div>
            <Menu
              theme="dark"
              defaultSelectedKeys={["1"]}
              mode="inline"
              style={{ marginTop: "70px", fontSize: "18px" }}
            >
              {role === "permitofficer" ? (
                <>
                  <Menu.SubMenu
                    key="SubMenu02"
                    title="Locational Permit"
                    icon={<SwitcherFilled />}
                  >
                    {role === "permitofficer" ? (
                      <>
                        <Menu.Item
                          key="sub2"
                          onClick={() =>
                            setContent("managelocationalclearance")
                          }
                        >
                          Generate LC
                        </Menu.Item>
                        <Menu.Item
                          key="sub5"
                          onClick={() => setContent("managecoe")}
                        >
                          Generate COE
                        </Menu.Item>
                      </>
                    ) : null}
                  </Menu.SubMenu>

                  <Menu.Item
                    key="5"
                    icon={<FileTextFilled />}
                    onClick={() => setContent("managelocationalcheckop")}
                  >
                    Check OP
                  </Menu.Item>
                  <Menu.Item
                    key="2"
                    icon={<FileTextFilled />}
                    onClick={() =>
                      setContent("managelocationalclearancereport")
                    }
                  >
                    Generate Report
                  </Menu.Item>
                </>
              ) : null}

              {role === "admin" ? (
                <>
                  <Menu.Item
                    key="2"
                    icon={<FileTextFilled />}
                    onClick={() => setContent("managelocationalPermitAdmin")}
                  >
                    Locational Permit
                  </Menu.Item>

                  <Menu.Item
                    key="12"
                    icon={<FileTextFilled />}
                    onClick={() => setContent("managelocationalcheckop")}
                  >
                    Check OP
                  </Menu.Item>

                  <Menu.Item
                    key="4"
                    icon={<FileTextFilled />}
                    onClick={() =>
                      setContent("managelocationalclearancereport")
                    }
                  >
                    Generate Report
                  </Menu.Item>
                </>
              ) : null}
            </Menu>
          </Sider>
          <Layout className="site-layout">
            <Header
              className="site-layout-background"
              style={{
                padding: 8,
                boxShadow: "0 2px 8px rgba(0, 0, 0, 0.15)",
                background: "#336699",
                color: "#fff",
                fontSize: "18px",
                fontWeight: "bold",
                borderBottom: "4px solid orange",
              }}
            >
              <span className="withLogo">
                <span style={{ marginRight: 20, fontSize: 14, marginTop: -10 }}>
                  Logged-in as:
                  <b style={{ textTransform: "uppercase" }}>
                    {role === "approver1"
                      ? `Division Chief [${user.fname}]`
                      : role === "approver4"
                      ? `Division Chief [${user.fname}]`
                      : role === "approver5"
                      ? `Department Head [${user.fname}]`
                      : role === "permitofficer"
                      ? ` ${user.fname}`
                      : role === "admin"
                      ? `Administrator [${user.fname}]`
                      : `Inspector [${user.fname}]`}
                  </b>
                </span>
                <Popover
                  content={contents}
                  placement="bottomRight"
                  trigger="hover"
                >
                  <img
                    className="homeProfile-img"
                    alt="Profile"
                    src="https://png.pngtree.com/png-vector/20200614/ourlarge/pngtree-businessman-user-avatar-character-vector-illustration-png-image_2242909.jpg"
                  />
                </Popover>
              </span>
            </Header>
            <Content
              style={{
                margin: "0 5px",
              }}
            >
              <Breadcrumb
                style={{
                  margin: "16px 0",
                }}
              >
                <Breadcrumb.Item></Breadcrumb.Item>
                <Breadcrumb.Item></Breadcrumb.Item>
              </Breadcrumb>
              <div
                style={{
                  padding: 8,
                  minHeight: 360,
                }}
              >
                {content === "managelocationalclearance" ? (
                  <LocationalClearance
                    assignedDepartment={role === "admin" ? "" : division}
                    ownerId={userId}
                    role={role}
                    division={division}
                    afterSubmit={() => setContent("managelocationalclearance")}
                  />
                ) : content === "managecoe" ? (
                  <COE
                    assignedDepartment={role === "admin" ? "" : division}
                    ownerId={userId}
                    role={role}
                    division={division}
                  />
                ) : content === "managelocationalcheckop" ? (
                  <CheckPaidOp
                    assignedDepartment={role === "admin" ? "" : division}
                    ownerId={userId}
                    role={role}
                    division={division}
                  />
                ) : content === "managelocationalclearancereport" ? (
                  <LocationalReports
                    assignedDepartment={role === "admin" ? "" : division}
                    ownerId={userId}
                    role={role}
                    division={division}
                  />
                ) : content === "managelocationalPermitAdmin" ? (
                  <Admin
                    assignedDepartment={role === "admin" ? "" : division}
                    ownerId={userId}
                    role={role}
                    division={division}
                  />
                ) : role === "approver4" && localStorage.getItem("isLogin") ? (
                  <Card
                    hoverable
                    style={{
                      width: "100%",
                      borderRadius: "16px",
                      boxShadow: "0 0 16px rgba(0, 0, 0, 0.1)",
                    }}
                  >
                    <Approver4 />
                  </Card>
                ) : role === "approver5" && localStorage.getItem("isLogin") ? (
                  <Card
                    hoverable
                    style={{
                      width: "100%",
                      borderRadius: "16px",
                      boxShadow: "0 0 16px rgba(0, 0, 0, 0.1)",
                    }}
                  >
                    <Approver5 />
                  </Card>
                ) : null}
              </div>
            </Content>

            <Footer
              style={{
                textAlign: "center",
              }}
            >
              Ant Design ©2018 Created by Ant UED
            </Footer>
          </Layout>
        </Layout>
      ) : null}
    </>
  );
};

export default Home;
